export const colorsBackground = [
  '#C0B7AC',
  '#939393',
  '#B69F82',
  '#555555',
  '#333333',
  '#C0B7AC',
]

export const colorsFonts = [
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
  '#F8F6EE',
]
